import React from "react";
import { Grid } from "@mui/material";
import ReportsDataTable from "./ReportsDataTable";

function Reports() {
  return (
    <>
      <Grid container justifyContent="space-evenly" spacing={0}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <ReportsDataTable />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default Reports;
